@if (faIcon()) {
  <div class="colored-circle-icon__fa-icon" [ngClass]="color()">
    <fa-icon [icon]="faIcon()"></fa-icon>
  </div>
} @else if (svgIcon()) {
  <div class="colored-circle-icon__svg-icon">
    <mat-icon [svgIcon]="svgIcon()"></mat-icon>
  </div>
}
